export const ALERT_TYPE: any = {
    DISCHARGE: 'Discharge',
    TRANSFERRED: 'Transfer',
    ADMITTED: 'Arrival'
}